import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { Toggle } from '@scripts/woo_components.module/toggle/toggle.component';
import { ContextMessage } from '@src/shared/feedback/context-message/context-message.component';
import { DotLoader } from '@src/shared/feedback/loader/dot-loader.component';
import { AvailableIconsStyle } from './components/icons/available-icons-style-component';
import { StyleSheet } from './components/style_sheet/style-sheet.component';
import { LoadButtonStyles } from './components/woo_load_button_styles/load-button-styles.component';

@NgModule({
  imports: [CommonModule, FormsModule, DotLoader, Toggle, WooComponentsModule, ContextMessage],
  providers: [],
  declarations: [LoadButtonStyles, StyleSheet, AvailableIconsStyle],
  exports: [LoadButtonStyles],
})
export class WooStyleSheetModule {}
